/**
 * Enable retailer marketing page updates that are specific to the US.
 * https:www.figma.com/design/JgZOyIXSInH1eIHBst0ThJ/Insider-Partnership-M2%2FM3?node-id=11420-36409&t=DloMdi80C5nn7Y31-0
 * Product Area: INSIDER
 */
export const INSIDER_MARKETING_PAGE_UPDATES_240812 = 'INSIDER_MARKETING_PAGE_UPDATES_240812';
